import React from 'react'

import SidebarLinkItem from '@/components/layouts/DashboardLayout/components/DashboardSidebar/components/SidebarLinkItem'
import { SidebarMenu } from '@/components/ui/sidebar'
import { SidebarLink } from '@/types/misc'

interface Props {
  links: SidebarLink[]
}

const SidebarLinks: React.FC<Props> = ({ links }) => {
  if (links.length === 0) {
    return null
  }

  return (
    <SidebarMenu className="px-5 group-data-[collapsible=icon]:px-1 gap-y-1.5">
      {links.map((link) => (
        <SidebarLinkItem key={link.title} link={link} />
      ))}
    </SidebarMenu>
  )
}

export default SidebarLinks
